module.exports = __webpack_public_path__ + "img/Hungary - Logo.42c3eab0.jpg";